import { render } from "./USGTemplates.vue?vue&type=template&id=4f7ece48"
import script from "./USGTemplates.vue?vue&type=script&lang=js"
export * from "./USGTemplates.vue?vue&type=script&lang=js"
script.render = render

export default script